import { FC, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import AppBar from 'components/AppBar';
import { Button } from 'components/Buttons';

const AlreadyPassedPage:FC = () => {
  const navigateTo = useNavigateTo();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const email = queryParams.get('email');

  return (
    <Fragment>
      <PublicDevicePlayable />
      <AppBar  />
      <div className="grow p-4 overflow-y-auto">
        <h2 className="text-center text-md">
          You already passed this quiz as
        </h2>
        <h2 className="font-bold text-center text-md mb-4">
          {email}
        </h2>
        <h2 className="text-center text-md mb-6">
          Please click button below to see your scrore.
        </h2>
        <div className="text-center">
          <Button
            className="capitalize"
            onClick={() => navigateTo('post-quiz')}
          >
            Show Score
          </Button>
        </div>
      </div>
    </Fragment>
  );
}

export default AlreadyPassedPage;
